<template>
  <div class="content line_height">
    <div class="w-e-text" v-html="data"></div>
    <div v-if="showOthers[platform]" class="attachment">
      <span>附件：</span>
      <span class="SDK" @click="toThreeSDK">《第三方SDK目录》</span>
    </div>
  </div>
</template>

<script>
import http from '@/utils/axios'
export default {
  data() {
    return {
      platform: this.$route.query.platform,
      data: '',
      urlObj:{
        'user': 'sys/admin/sys_var/privacyAgreement', //用户隐私政策
        'bees': 'sys/admin/sys_var/beesPrivacyAgreement', //员工隐私政策
        'beesfx': 'sys/admin/sys_var/findBeesDistServiceAgreement', //员工分销服务协议
        'branchfx': 'sys/admin/sys_var/distributionAgreement' //店铺分销服务协议
      },
      titleCN:{
        'user': '隐私协议', //用户隐私政策
        'bees': '隐私协议', //员工隐私政策
        'beesfx': '分销服务协议', //员工分销服务协议
        'branchfx': '分销服务协议',//店铺分销服务协议
      },
      showOthers:{
        'user': true,
        'bees': true , 
        'beesfx': false, 
        'branchfx': false,
      }
    }
  },
  mounted(){
    upsdk.setNavigationBarTitle({
      title:  this.titleCN[this.platform]
    });
  },
  created() {
    document.title = this.titleCN[this.platform];
    this.init();
  },
  methods: {
    init() {
      let url = this.urlObj[this.platform] || 'sys/admin/sys_var/privacyAgreement';
      http({
        url: url,
        method: 'get',
        parmes: {}
      }).then(res => {
        if (res.code == 200) {
          this.data = res.data
          this.$loading.hide();
        }
      })
    },
    toThreeSDK() {
      this.$router.push({
        path: '/directorySDK',
        query: {
          platform: this.platform
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 30px 30px 30px;
  .attachment {
    margin-top: 40px;
    font-size: 26px;
    .SDK {
      text-decoration: underline;
    }
  }

  /deep/.w-e-text {
      padding: 0 10px;
      overflow-y: scroll;
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        th {
            border-bottom: 2px solid #ccc;
            text-align: center;
        }
        td, th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 3px 5px;
        }
      }
      p,  h1,  h2,  h3,  h4,  h5,  table,   pre {
        margin: 10px 0;
        line-height: 1.5;
      }
      blockquote {
          display: block;
          border-left: 8px solid #d0e5f2;
          padding: 5px 10px;
          margin: 10px 0;
          line-height: 1.4;
          font-size: 100%;
          background-color: #f1f1f1;
      }
      img {
          cursor: pointer;
      }
  }
}


</style>